import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { DECISION_TREE, TIERS } from "@/data/content";
import { openWhatsApp } from "@/lib/api";
import { SectionEyebrow } from "@/components/Marquee";

export default function DecisionTree() {
  return (
    <section id="which-saarthi" className="relative py-20 md:py-28 bg-[#0A0A0F]" data-testid="decision-tree-section">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <SectionEyebrow n="Ch. III" testId="decision-tree-eyebrow">Find Your Saarthi</SectionEyebrow>
        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1, ease: [0.8, 0, 0.2, 1] }}
          className="mt-6 font-serif text-white text-5xl sm:text-6xl md:text-7xl leading-[0.98] tracking-tight max-w-4xl"
        >
          Which Saarthi do <span className="italic gradient-text">you need?</span>
        </motion.h2>

        <div className="mt-16 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {DECISION_TREE.map((d, i) => {
            const tier = TIERS.find((t) => t.id === d.tier);
            return (
              <motion.article
                key={d.q}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.7, delay: i * 0.08 }}
                className="relative rounded-3xl border border-white/5 bg-surface p-7 md:p-8 flex flex-col justify-between"
                data-testid={`decision-card-${i}`}
              >
                <div>
                  <p className="font-serif text-xl md:text-2xl text-white leading-snug">"{d.q}"</p>
                  <p className="mt-4 text-sm text-silver/60 leading-relaxed">{d.body}</p>
                </div>
                <div className="mt-8 flex items-center justify-between">
                  <span
                    className="font-serif text-2xl"
                    style={{ color: tier?.color || "#E8E8ED" }}
                  >
                    {d.a}
                  </span>
                  {d.tier ? (
                    <Link
                      to={`/${d.tier}`}
                      className="inline-flex items-center gap-1.5 text-xs uppercase tracking-widest text-silver/70 hover:text-white transition-colors"
                      data-testid={`decision-cta-${i}`}
                    >
                      Go <ArrowRight className="w-3.5 h-3.5" />
                    </Link>
                  ) : (
                    <button
                      onClick={() => openWhatsApp({ source: "decision_tree", tier: d.a })}
                      className="inline-flex items-center gap-1.5 text-xs uppercase tracking-widest text-silver/70 hover:text-white transition-colors"
                      data-testid={`decision-cta-${i}`}
                    >
                      Go <ArrowRight className="w-3.5 h-3.5" />
                    </button>
                  )}
                </div>
              </motion.article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
